export default "__VITE_ASSET__BY1Gt2eh__"